<template>
  <div class="radio-group">
    <slot />
  </div>
</template>
<script>

export default {
  name: 'radio-group',
  data() {
    return {
      isEdit: false,
      checkedValue: null,
    };
  },
  methods: {
    onChange(value) {
      this.checkedValue = value;
      this.$emit('input', value);
    }
  },
  mounted() {
    this.checkedValue = this.value;
  },
  watch: {
    value(value) {
      this.isEdit = true;
      this.checkedValue = value;
      // console.log('watch', value);
    },
    defaultValue(value) {
      if (!this.isEdit) {
        this.checkedValue = value;
      }
    }
  },
  props: {
    defaultValue: {
      type: [String, Boolean, Number],
      default: null,
    },
    value: {
      type: [String, Boolean, Number],
      default: null,
    },
  },
}
</script>